/** @prettier */

/* eslint-disable indent-legacy */
import { List } from 'immutable';
import PropTypes from 'prop-types';
import React, { useCallback, useEffect, useState } from 'react';

import Spinner from '@xanadu/ui-shared/components/widgets/Spinner';

import ActiveMultiple from '../ActiveMultiple';

import style from './ActiveView.module.scss';

const ActiveView = ({
  isLoggedIn,
  getActiveMultiples,
  activeMultiples: multiples,
  activeMultiplesError,
  loadingMultiples,
}) => {
  const [activeMultipleIndex, setIndex] = useState(0);

  useEffect(() => {
    if (isLoggedIn) {
      getActiveMultiples();
    }
  }, [isLoggedIn]);

  const onShowMultipleDetails = useCallback(
    (newIndex) => {
      if (activeMultipleIndex === newIndex) {
        setIndex(-1);
      } else {
        setIndex(newIndex);
      }
    },
    [activeMultipleIndex]
  );

  return (
    <div className={style.main}>
      <div className={style.selections}>
        {loadingMultiples && <Spinner size="large" theme="dark" />}
        {activeMultiplesError ? (
          <span className={style.noActiveMultiples}>{activeMultiplesError}</span>
        ) : (
          <React.Fragment>
            {!loadingMultiples && multiples.size ? (
              multiples.map((multiple, index) => (
                <ActiveMultiple
                  key={multiple.get('id')}
                  multiple={multiple}
                  onShowDetails={onShowMultipleDetails}
                  showDetails={activeMultipleIndex === index}
                  index={index}
                />
              ))
            ) : (
              <span className={style.noActiveMultiples}>
                You currently have no active multiples
              </span>
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

ActiveView.propTypes = {
  getActiveMultiples: PropTypes.func.isRequired,
  activeMultiples: PropTypes.instanceOf(List).isRequired,
  activeMultiplesError: PropTypes.string.isRequired,
  loadingMultiples: PropTypes.bool.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

export default ActiveView;
